export class HiddenPlaceholder {
	public static readonly PlaceHolders = {
		Liveness_Check: '[Liveness_Check]',
		Invisible: '[Invisible]',
	} as const;

	/**
	 * @description Check if the field is a hidden field
	 * @param key
	 */
	static isHiddenPlaceHolder(key: string): boolean {
		if (!key) return false;
		return Object.values(HiddenPlaceholder.PlaceHolders).some((placeHolder: string) => key.startsWith(placeHolder));
	}

	/**
	 * @description append the placeholder to the title
	 */
	static addHiddenPlaceHolder(title: string, placeHolder: string): string {
		return placeHolder + title;
	}

	/**
	 * @description Remove the placeholder from the title
	 */
	static removeHiddenPlaceHolder(title: string): string {
		return Object.values(HiddenPlaceholder.PlaceHolders).reduce((title: string, placeHolder: string) => title.replace(placeHolder, ''), title);
	}
}
